import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MagicWand01 = function MagicWand01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m13.0001 14-3-3m5.0103-7.5V2m3.9394 3.0607L20.0104 4m-1.0606 9 1.0606 1.0607m-9-9L9.9498 4m10.5606 5h1.5M6.1314 20.8686l9.2373-9.2372c.396-.396.594-.5941.6682-.8224a1 1 0 0 0 0-.618c-.0742-.2284-.2722-.4264-.6682-.8224l-.7372-.7372c-.3961-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2284.0742-.4264.2722-.8224.6682l-9.2372 9.2372c-.396.396-.594.5941-.6682.8224a1 1 0 0 0 0 .618c.0741.2283.2722.4264.6682.8224l.7372.7372c.396.396.594.5941.8224.6682a1 1 0 0 0 .618 0c.2283-.0741.4264-.2722.8224-.6682"
    })
  }));
};
export default MagicWand01;